import { render } from "./SummaryAndConfirmation.vue?vue&type=template&id=49a06040&scoped=true&bindings={\"terms\":\"data\",\"enquirySourceID\":\"data\",\"hasInvalidFields\":\"options\",\"bookedHireItems\":\"options\",\"holidayTotal\":\"options\",\"uk2ISO\":\"options\",\"ISO2Uk\":\"options\",\"continueToPayment\":\"options\",\"enqSourceChanged\":\"options\",\"saveToDatabase\":\"options\"}"
import script from "./SummaryAndConfirmation.vue?vue&type=script&lang=js"
export * from "./SummaryAndConfirmation.vue?vue&type=script&lang=js"

import "./SummaryAndConfirmation.vue?vue&type=style&index=0&id=49a06040&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-49a06040"

export default script